import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listSubjects, createSubject, updateSubject, deleteSubject } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

const HappySchoolSubjects = () => {
  const schoolId = getActiveSchoolId();
  const [subjects, setSubjects] = useState([]);
  const [name, setName] = useState("");
  const [blockSize, setBlockSize] = useState(2);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const reload = () => {
    if (!schoolId) return;
    setLoading(true);
    listSubjects(schoolId)
      .then(setSubjects)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(reload, [schoolId]);

  if (!schoolId) {
    return (
      <div style={{ padding: 24 }}>
        Chưa chọn trường. Vào <Link to="/happyschool/schools">Trường của tôi</Link> trước.
      </div>
    );
  }

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await createSubject(schoolId, { name: name.trim(), blockSize: Number(blockSize) });
      setName("");
      setBlockSize(2);
      reload();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleBlockSizeChange = async (subjectId, value) => {
    try {
      await updateSubject(schoolId, subjectId, { blockSize: Number(value) });
      reload();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleDelete = async (subjectId) => {
    try {
      await deleteSubject(schoolId, subjectId);
      reload();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={{ padding: 24, maxWidth: 700, margin: "0 auto" }}>
      <h2 style={{ margin: "0 0 16px 0" }}>Môn học</h2>

      <form onSubmit={handleCreate} style={{ display: "flex", gap: 8, marginBottom: 24, alignItems: "center" }}>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Tên môn học"
          style={{ flex: 1, padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}
        />
        <label style={{ fontSize: 13, color: "#4b5563" }}>Tiết liền khối/buổi</label>
        <input
          type="number"
          min={1}
          max={5}
          value={blockSize}
          onChange={(e) => setBlockSize(e.target.value)}
          style={{ width: 60, padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}
        />
        <button type="submit" style={btnStyle}>
          Thêm môn
        </button>
      </form>

      {error && <p style={{ color: "#dc2626" }}>{error}</p>}
      {loading ? (
        <p>Đang tải...</p>
      ) : subjects.length === 0 ? (
        <p style={{ color: "#6b7280" }}>Chưa có môn học nào.</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={thStyle}>Môn</th>
              <th style={thStyle}>Tiết liền khối/buổi</th>
              <th style={thStyle}></th>
            </tr>
          </thead>
          <tbody>
            {subjects.map((s) => (
              <tr key={s.id}>
                <td style={tdStyle}>{s.name}</td>
                <td style={tdStyle}>
                  <input
                    type="number"
                    min={1}
                    max={5}
                    defaultValue={s.blockSize}
                    onBlur={(e) => handleBlockSizeChange(s.id, e.target.value)}
                    style={{ width: 60, padding: 4, border: "1px solid #d1d5db", borderRadius: 4 }}
                  />
                </td>
                <td style={tdStyle}>
                  <button onClick={() => handleDelete(s.id)} style={dangerBtnStyle}>
                    Xoá
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

const btnStyle = { padding: "8px 16px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600 };
const dangerBtnStyle = { padding: "4px 10px", background: "#fee2e2", color: "#b91c1c", border: "1px solid #fca5a5", borderRadius: 6, cursor: "pointer" };
const thStyle = { border: "1px solid #e5e7eb", padding: "8px 10px", background: "#f9fafb", textAlign: "left" };
const tdStyle = { border: "1px solid #e5e7eb", padding: "8px 10px" };

export default HappySchoolSubjects;
